module.exports = __webpack_public_path__ + "img/default-portrait_in.a95ed130.png";